// Zero-based inclusive bounds. The count, not the final index, is capped.
export const MAX_RANGE_FILES = 10000;
export function estimateImportDuration(count) {
  return `${Math.floor((3 * count) / 100)} sec`;
}
function integer(value) {
  const text = String(value).trim();
  if (!/^\d+$/.test(text) || !Number.isSafeInteger(Number(text))) {
    throw new Error('Enter a non-negative whole number in both fields.');
  }
  return Number(text);
}
export function normalizeImportRange(from, to, total, resetEnd = false) {
  if (!Number.isSafeInteger(total) || total < 1) throw new Error('No SCP files available.');
  const start = Math.min(integer(from), total - 1);
  const defaultEnd = Math.min(start + 100, total - 1);
  const requestedEnd = resetEnd ? defaultEnd : integer(to);
  const end = Math.min(
    requestedEnd < start ? defaultEnd : requestedEnd,
    total - 1,
    start + MAX_RANGE_FILES - 1
  );
  return { start, end, count: end - start + 1 };
}
export function selectImportRange(prepared, range) {
  const valid = normalizeImportRange(range.start, range.end, prepared.files.length);
  return prepared.files.slice(valid.start, valid.end + 1);
}
